/*
 * Animation for the Global Freight's location map
 */
raymont.mapFreight = function(mapFreightElement) {

    var svg = $(mapFreightElement.getSVGDocument().documentElement),
        mapContents = $('.map-content'),
        mexicoContainer = svg.find('#mexique'),
        usaContainer = svg.find('#usa'),
        canadaContainer = svg.find('#canada'),
        containerImg = svg.find('#container');

    svg.click(function(evt){
        if(evt.target.tagName === 'svg'){
            resetAllCountriesSelected();
            toggleContent(mapContents, 'default');
            containerImg.css('display', 'block');
        }
    });

    var resetAllCountriesSelected = function() {
        svg.find('.countrySelected').removeClass('countrySelected');
        svg.find('.countryTextSelected').removeClass('countryTextSelected');
    };

    var highlightCountry = function(countrySelected) {
        containerImg.css('display', 'none');
        countryBkgdsElements = countrySelected.find('.st0');
        countryTextElements = countrySelected.find('.st4 .st5');

        countryBkgdsElements.each(function(){
            $(this).addClass('countrySelected');
        });

        countryTextElements.each(function(){
            $(this).addClass('countryTextSelected');
        });
    };

    var toggleContent = function(htmlElements, countrySelected) {
        htmlElements.each(function(){
            if($(this).hasClass(countrySelected + '-content')){
                $(this).removeClass('hidden');
            }
            else {
                $(this).addClass('hidden');
            }

        });
    };

    mexicoContainer.click(function(){
        resetAllCountriesSelected();
        highlightCountry(mexicoContainer);
        toggleContent(mapContents, 'mexico');
    });

    usaContainer.click(function(){
        resetAllCountriesSelected();
        highlightCountry(usaContainer);
        toggleContent(mapContents, 'usa');
    });

    canadaContainer.click(function(){
        resetAllCountriesSelected();
        highlightCountry(canadaContainer);
        toggleContent(mapContents, 'canada');
    });
};